module.exports = __webpack_public_path__ + "miscusi-static/fonts/icomoon.281ad861fd6cf572f9c52fc227e72eb4.woff2";